import type { SelfView } from "@bezbolisno/contracts/telegram";
import { t } from "@bezbolisno/i18n";
import { kyivDateTimeLabel } from "@bezbolisno/kit/kyiv-date";
import { appointmentStatus } from "./labels";
import { Section } from "./Section";

/** Still-booked visits from now on, soonest first. Past and cancelled ones are noise here. */
export function AppointmentList({ appointments }: { appointments: SelfView["appointments"] }) {
  const now = Date.now();
  const upcoming = appointments
    .filter((a) => a.status === "booked" && Date.parse(a.startsAt) >= now)
    .sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt));

  return (
    <Section title={t.appointments.tab}>
      {upcoming.length === 0 ? (
        <div className="tg-hint">{t.telegram.noUpcoming}</div>
      ) : (
        upcoming.map((a) => (
          <div key={a.id} className="tg-row">
            <span>{kyivDateTimeLabel(new Date(a.startsAt))}</span>
            <span className="tg-chip">{appointmentStatus(a.status)}</span>
          </div>
        ))
      )}
    </Section>
  );
}
